import * as ReactGA from 'react-ga';

// To track any dom element,
// enable event listener in src/index
// add data-action="<human readable short description>"
const eventTracker = appRootNode => {
  const handleClickEventTracking = event => {
    const { target } = event;

    let pageNode;

    const page = (function getPageDataset() {
      let p;
      let t = target;
      while (!p && t !== appRootNode) {
        if (t && t.hasAttribute && t.hasAttribute('data-page')) {
          p = t.getAttribute('data-page');
          pageNode = t;
          break;
        }
        t = t.parentElement || t.parentNode;
        if (t === null) break;
      }
      return p;
    })();

    if (pageNode) {
      let actionNode;
      const action = (function getPageDataset() {
        let a;
        let t = target;
        while (!a && t !== pageNode) {
          if (t && t.hasAttribute && t.hasAttribute('data-action')) {
            a = t.getAttribute('data-action');
            actionNode = t;
            break;
          }
          t = t.parentElement || t.parentNode;
          if (t === null) break;
        }
        if (!a && t.hasAttribute('data-action')) {
          a = t.getAttribute('data-action');
          actionNode = t;
        }
        return a;
      })();

      if (page && action) {
        const eventData = {
          category: page,
          action,
        };

        if (actionNode) {
          if (actionNode.hasAttribute('data-label')) {
            eventData.label = actionNode.getAttribute('data-label');
          }
          try {
            if (actionNode.hasAttribute('data-value')) {
              eventData.value = parseInt(
                actionNode.getAttribute('data-value'),
                10,
              );
            } else if (pageNode.hasAttribute('data-value')) {
              eventData.value = parseInt(
                pageNode.getAttribute('data-value'),
                10,
              );
            }
          } catch (err) {
            // nothing
          }

          if (actionNode.hasAttribute('data-transport')) {
            eventData.transport = actionNode.getAttribute('data-transport');
          }
        }
        // console.log(eventData)
        // Fire Google Analytics Event Tracking
        ReactGA.event(eventData);
      }
    }
  };
  window.addEventListener('click', handleClickEventTracking);
};

export const initializeAnalytics = (ua, appRoot) => {
  const options = {
    debug: true,
  };

  // eslint-disable-next-line no-underscore-dangle
  if (process.env.__PRODUCTION__) {
    options.debug = false;
  }

  ReactGA.initialize(ua, options);
  eventTracker(document.getElementById(appRoot));
};

export const PageTracker = props => {
  const { children, location } = props;
  const { pathname, search } = location;

  ReactGA.pageview(pathname + search);

  return [children];
};



// WEBPACK FOOTER //
// ./src/analytics/ReactGA/ReactGA.jsx